import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import MarriageForm from './form';
import {
  NewPersonVM,
  AccordionMarriage,
} from 'shell/components/shared/sipo-person-form/new-person';

const MarriageComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldMarriageChange = useEventCallback(
    (key: keyof AccordionMarriage, value: AccordionMarriage[keyof AccordionMarriage]) => {
      formContext.setFieldValue('marriage', {
        ...(formContext.values.marriage || {}),
        [key]: value,
      });
    }
  );

  const onFieldsMarriageChange = useEventCallback((values: AccordionMarriage) => {
    formContext.setFieldValue('marriage', {
      ...formContext.values.marriage,
      ...values,
    });
  });

  const resetForm = useCallback(() => {
    formContext.setValues({
      ...formContext.values,
      marriage: {
        documentDate: null,
        documentNumber: '',
        foreign: undefined,
        from: null,
      },
    });
  }, [formContext.values, formContext.setValues]);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-marriage-content"
        id="panel-person-marriage-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>
          Matrimonio
          {formContext?.errors?.marriage && formContext?.touched?.marriage ? (
            <Typography style={{ color: '#d6012e', display: 'inline', paddingLeft: '10px' }}>
              Attenzione verificare dati errati o mancanti
            </Typography>
          ) : undefined}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <MarriageForm
          values={formContext.values.marriage}
          onChange={onFieldMarriageChange}
          onFieldsChange={onFieldsMarriageChange}
          resetForm={resetForm}
          errors={formContext.errors.marriage as FormikErrors<AccordionMarriage>}
          touched={formContext.touched.marriage as unknown as FormikTouched<AccordionMarriage>}
        />
      </AccordionDetails>
    </Accordion>
  );
};

MarriageComponent.displayName = 'Accordion marriage component';

const Marriage = memo(MarriageComponent);

export default Marriage;
